// ── Layout heights (the source of truth) ──
const layoutHeight = {
  "app-bar": "48px",
  "app-bar-providersearch": "82px",
  navbar: "var(--navbar-height)",
  "navbar-main": "56px",
  "navbar-top": "28px",
  "patient-menu": "var(--patient-menu-height)",
  "search-type-tabs": "2.75rem",
  "step-menu": "var(--step-menu-height)",
  tabs: "var(--tabs-height)",
} as const;

// ── Raw dimension constants ──
export const CAROUSEL_IMAGE_HEIGHT = "200px";
export const CAROUSEL_LOGO_HEIGHT = "180px";
export const DEFAULT_THUMBNAIL_WIDTH = "88px";
export const DEFAULT_THUMBNAIL_HEIGHT = "88px";
export const INFO_WIDTH = "750px";

// ── Tailwind theme extensions ──
export const height = {
  ...layoutHeight,
  "carousel-image": CAROUSEL_IMAGE_HEIGHT,
  "carousel-logo": CAROUSEL_LOGO_HEIGHT,
  thumbnail: DEFAULT_THUMBNAIL_HEIGHT,
} as const;

export const width = {
  thumbnail: DEFAULT_THUMBNAIL_WIDTH,
} as const;

export const maxWidth = {
  "patient-info": INFO_WIDTH,
} as const;

export const minHeight = {
  "below-navbar": "calc(100vh - var(--navbar-height))",
  "below-navbar-patient-menu":
    "calc(100vh - var(--navbar-height) - var(--patient-menu-height))",
  "below-navbar-patient-menu-tabs":
    "calc(100vh - var(--navbar-height) - var(--patient-menu-height) - var(--tabs-height))",
} as const;

export const strokeWidth = {
  lg: "2px",
  md: "1.75px",
  sm: "1.5px",
} as const;

export const spacing = {
  "navbar-height": "var(--navbar-height)",
  "patient-menu-height": "var(--patient-menu-height)",
  "step-menu-height": "var(--step-menu-height)",
  "tabs-height": "var(--tabs-height)",
} as const;

export const zIndex = {
  "confirm-modal": "100001",
  modal: "102",
  navbar: "101",
  // Keep below app modals (z-modal is 102) so modals/popovers appear above the chat button
  "salesforce-chat": "50",
  toast: "9999999",
} as const;
